export default {"src":"/_next/static/media/logo.af2c22ef.svg","height":49,"width":253,"blurWidth":0,"blurHeight":0};